import { ThemeOptions } from 'src/client/components/Providers/ThemeProvider';

export const camLogoUrl = (cdnUrl: string, domain: string, theme: ThemeOptions) =>
  `${cdnUrl}/cam/${domain.toLowerCase().replace(/\./g, '_')}_${theme}.svg`;
